import { IconProp } from "@fortawesome/fontawesome-svg-core"

import { faIcon } from "@utils/faIcon"

import { FileCategory } from "./fileUpload"

/**
 * Maps file categories to their corresponding FontAwesome icons
 * Used by FileThumbnail, DocumentDownload, and other file display components
 */
export const FILE_CATEGORY_ICONS: Record<FileCategory, IconProp> = {
    image: faIcon({ name: "image", style: "solid" }),
    gif: faIcon({ name: "gif", style: "solid" }),
    audio: faIcon({ name: "headphones", style: "solid" }),
    video: faIcon({ name: "video", style: "solid" }),
    pdf: faIcon({ name: "file-pdf", style: "solid" }),
    word: faIcon({ name: "file-word", style: "solid" }),
    spreadsheet: faIcon({ name: "table", style: "solid" }),
    presentation: faIcon({ name: "presentation-screen", style: "solid" }),
    markdown: faIcon({ name: "code", style: "solid" }),
    svg: faIcon({ name: "bezier-curve", style: "solid" }),
    archive: faIcon({ name: "box-archive", style: "solid" }),
    unknown: faIcon({ name: "file", style: "solid" }),
}
